<template>
  <div class="AssessDetails">
    <TopNavBar navtitle="考官评审"></TopNavBar>
    <div class="enrolllist" v-if="ExamFormInfo">
      <ul class="examinfo">
        <h1>{{ ExamFormInfo.ExamBatch.EB_Name }}</h1>
        <img class="papers" :src="ExamFormInfo.Photo" alt />
        <li>
          <label for="">姓名：</label>
          <span>{{ ExamFormInfo.Name }}</span>
        </li>
        <li>
          <label for="">编号：</label>
          <span>{{ ExamFormInfo.ExamNO }}</span>
        </li>
        <li>
          <label for="">专业：</label>
          <span class="warning">{{ ExamFormInfo.Majors.MName }}</span>
        </li>
        <li>
          <label for="">级别：</label>
          <span class="warning">{{ ExamFormInfo.Grades.GName }}</span>
        </li>
      </ul>
      <ul v-if="ReviewList && ExamFormReviewList">
        <h1>
          评审项目：{{ ExamFormInfo.Majors.MName }}
          {{ ExamFormInfo.Grades.GName }}
        </h1>
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item
            v-for="(item, index) in ExamFormReviewList"
            :key="item.EAS_ID"
            :name="index"
          >
            <template #title>
              <div>
                <strong
                  ><b
                    >{{ item.ExamQuestionType.TypeName }}({{
                      chin_list[item.EQT_ID]
                    }})
                  </b></strong
                >
                <span
                  class="danger"
                  v-if="
                    ExamFormInfo.Majors.ParentID == -1 &&
                      Object.keys(ReviewList[item.EAS_ID]).length == 0
                  "
                  >（未评审）</span
                >
                <span
                  class="succeed"
                  v-if="
                    ExamFormInfo.Majors.ParentID == -1 &&
                      Object.keys(ReviewList[item.EAS_ID]).length > 0
                  "
                  >（已评审）</span
                >
              </div>
            </template>
            <div class="remark" v-if="ExamFormInfo.Majors.ParentID == -1">
              <!--乐器类评审 -->
              <h1>{{ item.View_ExamQuestion.Question }}</h1>
              <h3 v-if="item.Answer == ''">
                <van-tag type="danger" size="medium">考生未上传视频！</van-tag>
              </h3>
              <van-sticky
                :offset-top="0"
                v-if="item.Answer != ''"
                z-index="100"
              >
                <video
                  x5-playsinline=""
                  playsinline=""
                  webkit-playsinline=""
                  v-if="item.Answer != ''"
                  :src="
                    item.FormatAnswer == '' ? item.Answer : item.FormatAnswer
                  "
                  controls
                  width="100%"
                  height="200"
                ></video>
                <van-button
                  v-if="item.Similarity >= 0.7 && item.Similarity <= 1"
                  type="primary"
                  >人脸识别相识度{{
                    Number(item.Similarity * 100).toFixed()
                  }}%</van-button
                >
                <van-button v-else-if="item.Similarity < 0.7" type="warning"
                  >人脸识别相识度{{
                    Number(item.Similarity * 100).toFixed()
                  }}%</van-button
                >
                <van-button v-else-if="item.Similarity == 2" type="warning"
                  >未检测到人脸信息</van-button
                >
                <br />
                <br />
                <van-button
                  v-if="
                    item.View_ExamQuestion.MusicScore &&
                      item.View_ExamQuestion.MusicScore != ''
                  "
                  type="primary"
                  @click="ShowMusicScore(item.View_ExamQuestion.MusicScore)"
                  >查看曲谱</van-button
                >
              </van-sticky>
              <div class="review" v-if="item.Answer != ''">
                <van-tabs v-model="active" sticky offset-top="200">
                  <van-tab
                    v-for="(ritem, rindex) in comments.filter(
                      s => s.type == 1
                    )[0].list"
                    :key="rindex"
                    :title="
                      ritem.title +
                        (ReviewList[item.EAS_ID][ritem.title] &&
                        ReviewList[item.EAS_ID][ritem.title]
                          ? '(已选)'
                          : '')
                    "
                    class="stickylaster"
                  >
                    <p>
                      <span
                        v-for="(citem, cindex) in ritem.comments"
                        :key="cindex"
                        :class="
                          ReviewList[item.EAS_ID][ritem.title] &&
                          ReviewList[item.EAS_ID][ritem.title].findIndex(
                            s => s == citem.info
                          ) >= 0
                            ? 'active'
                            : ''
                        "
                        @click="Review(item.EAS_ID, ritem.title, citem.info)"
                        >{{ citem.info }}</span
                      >
                    </p>
                  </van-tab>
                </van-tabs>
                <!-- <van-collapse v-model="reviewNames" >
                                    <van-collapse-item title="意见与建议栏" :name="index+5">
                                        <p>
                                            <span v-for="(pitem,pindex) in comments.filter(s=>s.type==1)[0].proposal" :key="pindex" :class="(ReviewList[item.EAS_ID]['意见与建议']&&ReviewList[item.EAS_ID]['意见与建议'].findIndex(s=>s==pitem)>=0)?'active':''" @click="Review(item.EAS_ID,'意见与建议',pitem)">{{pitem}}</span>
                                        </p>
                                    </van-collapse-item>
                                </van-collapse> -->
              </div>
              <van-field
                v-model="ReviewList[item.EAS_ID]['补充意见']"
                rows="2"
                autosize
                label=""
                type="textarea"
                maxlength="50"
                placeholder="请输入评审意见"
                show-word-limit
              />
            </div>

            <div class="remark" v-if="ExamFormInfo.Majors.ParentID == -2">
              <!-- 声乐类评审 -->
              <h1>{{ item.View_ExamQuestion.Question }}</h1>
              <h3 v-if="item.Answer == ''">
                <van-tag type="danger" size="medium">考生未上传视频！</van-tag>
              </h3>
              <van-sticky :offset-top="5" v-if="item.Answer != ''">
                <video
                  x5-playsinline=""
                  playsinline=""
                  webkit-playsinline=""
                  v-if="item.Answer != ''"
                  :src="
                    item.FormatAnswer == '' ? item.Answer : item.FormatAnswer
                  "
                  controls
                  width="100%"
                  height="200"
                ></video>
                <van-button
                  v-if="item.Similarity >= 0.7 && item.Similarity <= 1"
                  type="primary"
                  >人脸识别相识度{{
                    Number(item.Similarity * 100).toFixed()
                  }}%</van-button
                >
                <van-button v-else-if="item.Similarity < 0.7" type="warning"
                  >人脸识别相识度{{
                    Number(item.Similarity * 100).toFixed()
                  }}%</van-button
                >
                <van-button v-else-if="item.Similarity == 2" type="warning"
                  >未检测到人脸信息</van-button
                >
              </van-sticky>
            </div>
          </van-collapse-item>
        </van-collapse>
      </ul>
      <ul v-else>
        <h1 style="color:red">没有上传视频记录</h1>
      </ul>
      <!-- 综合评审 -->
      <ul>
        <div class="remark">
          <div class="review">
            <van-tabs
              v-model="active"
              v-if="ExamFormInfo.Majors.ParentID == -2"
            >
              <van-tab
                v-for="(ritem, rindex) in comments.filter(s => s.type == 2)[0]
                  .list"
                :key="rindex"
                :title="ritem.title"
              >
                <p>
                  <span
                    v-for="(citem, cindex) in ritem.comments"
                    :key="cindex"
                    :class="
                      ReviewList['综合评审'][ritem.title] &&
                      ReviewList['综合评审'][ritem.title].findIndex(
                        s => s == citem.info
                      ) >= 0
                        ? 'active'
                        : ''
                    "
                    @click="Review('综合评审', ritem.title, citem.info)"
                    >{{ citem.info }}</span
                  >
                </p>
              </van-tab>
            </van-tabs>
          </div>
        </div>
        <h1>综审成绩</h1>
        <p class="small" v-if="ERT_Code !== ''">
          您选择的综合成绩为：<span
            :class="ERT_Code < 2 ? 'danger' : 'succeed'"
            >{{
              resultCode.filter(s => s.ERT_Code == ERT_Code)[0].ERT_Name
            }}</span
          >
        </p>

        <div class="remark">
          <p>
            <span
              v-for="(item, index) in resultCode"
              :key="index"
              :name="item.ERT_Code"
              :class="item.ERT_Code === ERT_Code ? 'active' : ''"
              @click="onCheckedresult(item.ERT_Code)"
              >{{ item.ERT_Name }}</span
            >
          </p>

          <div class="review" v-if="ExamFormInfo.Majors.ParentID == -1">
            <van-collapse v-model="over">
              <van-collapse-item title="意见与建议栏" name="over">
                <p>
                  <span
                    v-for="(pitem, pindex) in comments.filter(
                      s => s.type == 1
                    )[0].proposal"
                    :key="pindex"
                    :class="
                      ReviewList['意见建议'] &&
                      ReviewList['意见建议']['意见与建议'] &&
                      ReviewList['意见建议']['意见与建议'].findIndex(
                        s => s == pitem
                      ) >= 0
                        ? 'active'
                        : ''
                    "
                    @click="Review('意见建议', '意见与建议', pitem)"
                    >{{ pitem }}</span
                  >
                </p>
              </van-collapse-item>
            </van-collapse>
          </div>
          <div class="review" v-if="ExamFormInfo.Majors.ParentID == -2">
            <van-collapse v-model="over">
              <van-collapse-item title="意见与建议栏" name="over">
                <p>
                  <span
                    v-for="(pitem, pindex) in comments.filter(
                      s => s.type == 2
                    )[0].proposal"
                    :key="pindex"
                    :class="
                      ReviewList['意见建议'] &&
                      ReviewList['意见建议']['意见与建议'] &&
                      ReviewList['意见建议']['意见与建议'].findIndex(
                        s => s == pitem
                      ) >= 0
                        ? 'active'
                        : ''
                    "
                    @click="Review('意见建议', '意见与建议', pitem)"
                    >{{ pitem }}</span
                  >
                </p>
              </van-collapse-item>
            </van-collapse>
          </div>
          <van-field
            v-model="Suggestion"
            rows="2"
            autosize
            label=""
            type="textarea"
            maxlength="50"
            placeholder="请输入综审意见"
            show-word-limit
          />
        </div>
      </ul>
      <ul v-if="signImg !== ''">
        <h1>考官签字</h1>
        <van-image width="300" height="200" :src="signImg" />
      </ul>
    </div>
    <div class="upvbtn" v-if="signImg === ''">
      <van-button
        block
        color="linear-gradient(to right, #5492f5, #5b60eb)"
        @click="commit"
        ><i class="iconfont icon-shangchuanshipin1"></i>
        确定提交考生成绩</van-button
      >
    </div>
    <div class="upvbtn" v-else>
      <van-button
        block
        color="linear-gradient(to right, #5492f5, #5b60eb)"
        @click="update"
        ><i class="iconfont icon-shangchuanshipin1"></i> 修改评语</van-button
      >
    </div>
    <van-dialog
      v-model="showCanvas"
      title="考官签名"
      show-cancel-button
      :before-close="saveAsImg"
    >
      <sign-canvas
        class="sign-canvas"
        ref="SignCanvas"
        :options="signOptions"
        v-model="signValue"
      />
    </van-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { ImagePreview, Toast, Dialog } from "vant";
import TopNavBar from "@/components/TopNavBar.vue";
import {
  GetExamFormReviewInfo,
  SubmitExaminerReview,
  ChangeExaminerReview
} from "@/api/examiner";
import comments from "@/assets/JSON/Comments.json";
import SignCanvas from "sign-canvas";
export default {
  components: {
    TopNavBar,
    SignCanvas
  },
  data() {
    return {
      showCanvas: false,
      signValue: null,
      signOptions: {
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        isShowBorder: false, //是否显示边框 [可选]
        canvasHeight: 400
      },
      comments: null,
      ExamFormInfo: null,
      ExamFormReviewList: null,
      EF_ID: 0,
      vshow: false,
      message: "",
      resultmessage: "",
      active: 0,
      activeNames: "",
      reviewNames: ["1"],
      over: ["0"],
      ReviewList: {},
      value: 0,
      ERT_Code: "",
      Suggestion: "",
      signImg: "",
      ER_ID: 0,
      resultCode: [
        { ERT_Code: 4, ERT_Name: "优秀" },
        { ERT_Code: 3, ERT_Name: "良好" },
        { ERT_Code: 2, ERT_Name: "及格" },
        { ERT_Code: 1, ERT_Name: "不及格" },
        { ERT_Code: 0, ERT_Name: "缺考" }
      ],
      chin_list: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"]
    };
  },
  created() {
    this.comments = comments;
    if (this.$route.query.EF_ID != undefined && this.$route.query.EF_ID > 0) {
      this.EF_ID = this.$route.query.EF_ID;
      GetExamFormReviewInfo({ EF_ID: this.EF_ID })
        .then(res => {
          this.ExamFormInfo = res.OtherMsg.ExamFormIno;
          this.ExamFormReviewList = res.listData;
          if (this.ExamFormInfo.Majors.ParentID == -1) {
            this.ExamFormReviewList.forEach(element => {
              //Vue.set(this.ReviewList, element.EAS_ID, [{"补充意见":""}]);
              Vue.set(this.ReviewList, element.EAS_ID, {});
            });
          }
          if (this.ExamFormInfo.Majors.ParentID == -2) {
            Vue.set(this.ReviewList, "综合评审", {});
          }

          Vue.set(this.ReviewList, "意见建议", {});
          console.log("this.ReviewList :>> ", this.ReviewList);
          if (
            res.OtherMsg.ExaminerReview &&
            res.OtherMsg.ExaminerReview.Judgement
          ) {
            this.ReviewList = JSON.parse(res.OtherMsg.ExaminerReview.Judgement);
            this.ERT_Code = res.OtherMsg.ExaminerReview.ERT_Code;
            this.ER_ID = res.OtherMsg.ExaminerReview.ER_ID;
            this.Suggestion = res.OtherMsg.ExaminerReview.Suggestion;
            this.signImg = res.OtherMsg.ExaminerReview.Signature;
            // this.ReviewList.forEach(element => {
            //   if(!element.getPrototypeOf("补充意见"))
            //   {
            //     Vue.set(element, "补充意见", "");
            //   }
            // });
            // }else{
            //   Toast.fail("没有上传视频的记录");
          }
          console.log("this.ReviewList :>> ", this.ReviewList);
        })
        .catch(() => {
          Toast.fail("没有上传视频记录");
          //this.$router.push('/Assessment');
        });
    } else {
      this.$router.push("/Assessment");
    }
  },
  methods: {
    onChecked(index) {
      this.reviewwell[index].ckb = this.reviewwell[index].ckb == 1 ? 0 : 1;
    },
    onCheckedresult(ERT_Code) {
      this.ERT_Code = this.ERT_Code == ERT_Code ? "" : ERT_Code;
    },
    commit() {
      console.log("this.ReviewList :>> ", this.ReviewList);

      let errMsg = "";

      if (this.ExamFormInfo.Majors.ParentID == -1) {
        for (var keys in this.ReviewList) {
          if (this.ReviewList[keys].length == 0) {
            let q = this.ExamFormReviewList.filter(s => s.EAS_ID == keys)[0];
            if (q.Answer != "") {
              errMsg +=
                q.ExamQuestionType.TypeName +
                ":" +
                q.View_ExamQuestion.Question +
                "\n";
            }
          }
        }
        if (errMsg.length > 0) {
          Dialog.alert({
            message: "下列曲目未评审\n" + errMsg
          });
          return;
        }
      }
      if (this.ERT_Code === "") {
        Toast.fail("请选择综合成绩");
        return;
      }

      this.showCanvas = true;
      Toast.fail("请签名确认");
    },
    Viewvideo: function() {
      this.vshow = true;
    },

    /**
     * 清除画板
     */
    canvasClear() {
      this.$refs.SignCanvas.canvasClear();
    },

    /**
     * 保存图片
     */
    saveAsImg(action, done) {
      if (action === "confirm") {
        const img = this.$refs.SignCanvas.saveAsImg();
        // console.log('img :>> ', img);
        SubmitExaminerReview({
          EF_ID: this.EF_ID,
          Judgement: JSON.stringify(this.ReviewList),
          ERT_Code: this.ERT_Code,
          Suggestion: this.Suggestion,
          Signature: img
        })
          .then(res => {
            Toast.success("评审成功");
            this.signImg = "已评审";
            done();
          })
          .catch(err => {
            done();
          });
      } else {
        this.canvasClear();
        done();
      }
    },
    /***
     *
     * 点击共性评价
     * */
    Review(EAS_ID, title, info) {
      // if (this.signImg != '') {
      //     Toast.fail('已提交评审不能修改');
      //     return;
      // }
      if (
        this.ReviewList &&
        this.ReviewList[EAS_ID] &&
        this.ReviewList[EAS_ID][title] &&
        this.ReviewList[EAS_ID][title].findIndex(s => s == info) >= 0
      ) {
        //取消选中
        this.ReviewList[EAS_ID][title].splice(
          this.ReviewList[EAS_ID][title].findIndex(s => s == info),
          1
        );
        if (
          this.ReviewList[EAS_ID][title].length == 0 &&
          this.ExamFormInfo.Majors.ParentID == -1
        ) {
          this.ReviewList[EAS_ID] = {};
        }
      } else {
        //选中
        if (!this.ReviewList[EAS_ID][title]) {
          if (this.ExamFormInfo.Majors.ParentID == -1) {
            this.ReviewList[EAS_ID] = {};
          }
          Vue.set(this.ReviewList[EAS_ID], title, []);
        }
        if (this.ExamFormInfo.Majors.ParentID == -2 && title != "意见与建议") {
          this.ReviewList[EAS_ID][title] = [info];
        } else {
          this.ReviewList[EAS_ID][title].push(info);
        }
      }
    },
    ShowMusicScore(MusicScore) {
      let imgList = MusicScore.split(",");
      if (imgList.length > 0) {
        ImagePreview({ images: imgList, closeable: true });
      }
    },
    update() {
      if (this.ER_ID == 0) {
        Toast.fail("请选择要修改的评语");
        return;
      }
      let that = this;
      Dialog.confirm({
        title: "提示",
        message: "确定要提交修改评语吗"
      })
        .then(() => {
          ChangeExaminerReview({
            ER_ID: that.ER_ID,
            Judgement: JSON.stringify(that.ReviewList),
            ERT_Code: that.ERT_Code,
            Suggestion: this.Suggestion,
            Signature: "ss"
          }).then(res => {
            Toast.success("修改成功");
          });
        })
        .catch(() => {
          Toast.fail("已取消修改");
        });
    }
  }
};
</script>

<style>
.van-cell__title div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.remark .review .van-tabs .van-tabs__content .van-tab__pane p,
.remark p {
  text-align: left;
  padding: 10px;
}
.remark .review .van-cell__title {
  text-align: left;
}
.remark .review .van-cell__title span {
  font-weight: bold;
  color: #333;
}
.remark .review .van-tabs .van-tabs__content .van-tab__pane p span,
.remark p span {
  background: #f2f2f2;
  color: #666;
  padding: 5px 15px;
  border-radius: 15px;
  margin: 3px;
  font-size: 3vw;
  display: inline-block;
}
.remark h3 {
  margin-bottom: 5px;
}
.enrolllist
  ul
  .van-collapse
  .van-collapse-item
  .van-collapse-item__wrapper
  .van-collapse-item__content {
  padding: 8px 0;
}
.remark .van-sticky--fixed {
  background: #fff;
}
.remark .van-field {
  border: solid 1px #f2f2f2;
  margin-bottom: 20px;
  border-radius: 5px;
}
.remark .review .van-tabs .van-tabs__content .van-tab__pane p span.active,
.remark p span.active {
  background: #f02458;
  color: #fff;
}
</style>
